module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-70"
  }, [_c('app-header'), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "pa-5": "",
      "mt-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "align-center": "",
      "fill-height": "",
      "mb-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "lg12": "",
      "sm12": "",
      "xs12": "",
      "md10": ""
    }
  }, [_c('div', {
    staticClass: "font-24"
  }, [_vm._v("FAQ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md10": "",
      "mt-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-card', {
    staticClass: "px-3 py-3",
    attrs: {
      "flat": ""
    }
  }, [_c('v-expansion-panel', {
    attrs: {
      "focusable": ""
    }
  }, [_c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v(_vm._s(_vm.$t('faq.faq1')))])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('faq.faqTxt1'))
    }
  })])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v(_vm._s(_vm.$t('faq.faq2')))])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('faq.faqTxt2'))
    }
  })])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v(_vm._s(_vm.$t('faq.faq3')))])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('faq.faqTxt3'))
    }
  })])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v(_vm._s(_vm.$t('faq.faq4')))])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('faq.faqTxt4'))
    }
  })])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v(_vm._s(_vm.$t('faq.faq5')))])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('faq.faqTxt5'))
    }
  })])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v(_vm._s(_vm.$t('faq.faq6')))])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('faq.faqTxt6'))
    }
  })])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v(_vm._s(_vm.$t('faq.faq7')))])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('faq.faqTxt7'))
    }
  })])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63ed15d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/about/FrequentlyAskedQuestions.vue
// module id = 448
// module chunks = 0